import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';

import CheckEmail from './CheckEmail';
import Form from './Form';

const deps = {
  hasSentPasswordEmail: state.account.hasSentPasswordEmail,
};

export function ForgotPassword({
  hasSentPasswordEmail,
}: typeof deps & ConnectedProps): React.ReactElement {
  return hasSentPasswordEmail ? <CheckEmail /> : <Form />;
}

export default connect(deps, ForgotPassword);
